import React, { FC } from 'react';
import { ContentType } from '@/swagger/constants/contents-orchestrator-enums';
import { useSkillsToBoost } from '../../hooks';
import { getContentsByTypeCall } from '../../state';
import { Cards } from '../Cards';

type Props = {
  content: NonNullable<ReturnType<typeof getContentsByTypeCall.hook>['data']>[number];
  halfHeightLayout?: boolean;
};

export const ContentToCard: FC<Props> = ({ content, halfHeightLayout }) => {
  const { isSkillToBoost } = useSkillsToBoost();

  const getIsSkillToBoost = (tags: typeof content.tags) => {
    if (!tags || tags.length === 0) return false;
    return tags.some(tag => isSkillToBoost(tag.label));
  };

  if (content.type === ContentType.VIDEO) {
    return (
      <Cards.Video
        id={content.id}
        key={content.id}
        category={content.tags?.[0]?.label}
        description={content.summary || ''}
        durationInMinutes={content.durationMinutes}
        inProgress={
          !!content.userDetails?.progress?.startedAt && !content.userDetails?.progress?.completedAt
        }
        rating={content.averageRating}
        title={content.title}
        thumbnailUrl={content.thumbnailUrl}
        isFavorite={content.userDetails?.favorite}
        isCompleted={content.userDetails?.progress?.completedAt !== undefined}
        isSkillToBoost={getIsSkillToBoost(content.tags)}
      />
    );
  }
  if (content.type === ContentType.PDF) {
    return (
      <Cards.Document
        id={content.id}
        key={content.id}
        category={content?.tags?.map(tag => tag.label)?.join(', ') || undefined}
        description={content.summary || ''}
        durationInMinutes={content.durationMinutes}
        inProgress={
          !!content.userDetails?.progress?.startedAt && !content.userDetails?.progress?.completedAt
        }
        title={content.title}
        rating={content.averageRating}
        isFavorite={content.userDetails?.favorite}
        isSkillToBoost={getIsSkillToBoost(content.tags)}
        isCompleted={content.userDetails?.progress?.completedAt !== undefined}
      />
    );
  }
  if (content.type === ContentType.QUIZ) {
    return (
      <Cards.Quiz
        id={content.id}
        category={content?.tags?.map(tag => tag.label)?.join(', ') || undefined}
        title={content?.title}
        halfHeightLayout={halfHeightLayout}
        key={content.id}
        inProgress={
          !!content.userDetails?.progress?.startedAt && !content.userDetails?.progress?.completedAt
        }
        questions={content.questionsCount}
        isFavorite={content.userDetails?.favorite}
        isSkillToBoost={getIsSkillToBoost(content.tags)}
        currentStep={Number(content.userDetails?.progress?.progress?.step)}
        totalSteps={Number(content.userDetails?.progress?.progress?.totalSteps)}
      />
    );
  }

  return null;
};
